import z from 'zod';

export const recipientSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string().nullable(),
  phoneNumber: z.string(),
});

export type Recipient = z.infer<typeof recipientSchema>;
